import { useEffect, useState } from "react";
import { getUserOffices } from "../api/userService";

export const useUserOffices = (userId, trigger) => {
    const [userOffices, setUserOffices] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getUserOffices(userId)
        .then(setUserOffices)
        .finally(() => setLoading(false));
    }, [userId, trigger]);

    return { userOffices, loading, setUserOffices };
};
